export const getClassName = (elementName: string) => `react-app-${elementName}`

export const getImageClassName = () => getClassName('image')
